<template>
  <div class="mb-3 bg-white rounded-lg shadow-md px-3 py-2.5">
    <h4 class="text-xl font-bold py-2">Logged Device Details</h4>
    <div class="relative overflow-x-auto my-2 mb-4 rounded-lg  border-gray-200 border-b border-t border-r border-l">
      <Table 
      :headers="headers" 
      :data="User[0].devices" 
      :row-key="['device_id', 'device_model', 'ip_address', 'modified']"
      :isLoading="isLoading" 
      :withPagination="false" 
         
      >
        <template #device_id="{ value }">
          <span>
            {{ value[0] }}
          </span>
        </template>
        <template #modified="{ value }">
            <span>{{ formatDateTime(value).date }}</span>
            <br>
            <span class="italic text-xs">{{ formatDateTime(value).time }}</span>
          </template>
        <template #actions="{ row }">
            <button class="bg-white border cursor-pointer p-2 rounded-lg" @click="showPopup(row.id)">
                Remove Device
              </button>
        </template>
      </Table>
     
      <t-modal ref="removeDeviceModal">
        <div class="text-sm flex-col text-center">
          <label class="text-center font-semibold">Remove this device?</label>
          <p class="text-left text-gray-500">
            The data of device will be lost, still want to continue?
          </p>
        </div>
        <div class="flex justify-center">
          <button class="bg-blue-500 text-white p-1 px-2 rounded-lg mr-1 text-sm" @click="cancel">
            Cancel
          </button>
          <button class="bg-white border text-gray-500 p-1 px-2 rounded-lg ml-1 text-sm" @click="handleRemoveDevice">
            Yes
          </button>
        </div>
      </t-modal>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapActions } from "vuex";
import moment from "moment";
import { EventBus } from '../../../../src/event-bus';
import Table from '@/components/form/table.vue'
export default {
  components:{
    Table
  },
  props: {
    User: {
      type: Array,
      required: true,
     default: () => ({})
    },
    id: {
      type: String,
      required: true
    },
    isLoading: {
      type:Boolean,
      required:false
    },
  },
  data() {
    return {
      headers: [
  { label: 'No', key: 'no' },
  { label: 'DEVICE ID', key: 'device_id' },
  { label: 'DEVICE TYPE', key: 'device_model' },
  { label: 'IMEI', key: 'ip_address' },
  { label: 'LAST MODIFIED', key: 'modified' }
],
      deviceIdToRemove: null,
    };
  },
  methods: {
    ...mapActions("users", ["fetchUserByid","deleteDeviceId"]),
    showPopup(id) {
      this.deviceIdToRemove = id;
      this.$refs.removeDeviceModal.show();
    },
    cancel() {
      this.$refs.removeDeviceModal.hide();
    },
    formatDate(date) {
      if (!date) return '';
      return format(new Date(date), 'dd MMM yyyy, HH:mm:ss');
    },
   formatDateTime(tgl) {
      return {
        date: moment(tgl).utc().format('DD MMM YY'),
        time: moment(tgl).utc().format('HH:mm:ss'),
      };
  },
    handleRemoveDevice() {
      this.deleteDeviceId(this.deviceIdToRemove).then((response)=> {
            if(response.status === 200) {
              EventBus.$emit('show-toast', {
              message: 'Device successfully deleted.',
              type: 'success'
              });
              this.actionGetUser()
            } 
      })
      this.$refs.removeDeviceModal.hide();
    },
    actionGetUser() {
      const payload = {
        id: this.id,
      }
      this.fetchUserByid(payload)
    },
  }
};
</script>

<style scoped>
/* Add any scoped styles here */
</style>
